module.exports = __webpack_public_path__ + "img/ad.e28ac34.svg";